module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"table w100\">\n	<div>\n		<div>\n			<div class=\"table wh100 form__edit-form\">\n				")
    ;  Util.each(widget.columns, function (column) { 
    ; __append("\n				<div>\n					<div>")
    ; __append(escapeFn( column.title ))
    ; __append("</div>\n					<div>")
    ; __append(escapeFn( widget.columnContent(column) ))
    ; __append("</div>\n				</div>\n				")
    ;  }) 
    ; __append("\n			</div>\n		</div>\n		<div class=\"form__edit-form_buttons cell__right w0\">\n				<div>\n					<button class=\"button__save w100\" on-click=\"onSaveClick\">Сохранить</button>\n				</div>\n				<div>\n					<button class=\"button__save w100\" on-click=\"onSaveCloseClick\">Сохранить и закрыть</button>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>")
  }
  return __output.join("");

}